import mapaDeRotas from "@/router/caminho-urls";
import axios from "axios";
import {getTokenAuth} from "@/stores/auth";

export async function AtualizaCadastro(dados) {
    const isDevEnvironment = process.env.VUE_APP_NODE_ENV === "development";
    const token_base = isDevEnvironment ? await getTokenAuth() : null;
    const caminho = new mapaDeRotas();
    const formData = new FormData();

    for (const key in dados) {
        formData.append(key, dados[key]);
    }

    const config = {
        method: 'POST',
        url: `${caminho.rota_api}/usuario/editar-usuario`,
        data: formData,
        headers: {
            "content-Type": "multipart/form-data",
            ...(token_base && { "Authorization": token_base })
        }
    };
    const requisicao = await axios(config)
        .then(response => {
            return response.data;
        })
        .catch(err => {
            return err.response;
        });
    return requisicao;
}